import {create} from 'zustand'

// State Management for modal components
const modalStateStore = create((set, get) => ({
	globalModalContent: null,

	// Setter methods
	setGlobalModalContent: (content) => set({ globalModalContent: content }),
	resetGlobalModalContent: () => set({ globalModalContent: null }),

	// Getter to check if modal is open
	getGlobalModalContent: () => get().globalModalContent
}))

export default modalStateStore